import React from 'react';

import Intro from './Intro';
import Skills from './Skills';
import Projects from './Projects';

const Home = () => {
    return (
        <>
            <Intro />
            <Skills />
            <Projects />
        </>
    )
}

export default Home;